import { compareImageNodes, compareTextNodes } from '../canvas/geometry.js'

export function sortImageNodes(nodes) { return [...(nodes || [])].sort(compareImageNodes) }
export function sortTextNodes(nodes) { return [...(nodes || [])].sort(compareTextNodes) }

export function uniqueRefs(refs) {
  const seen = new Set()
  return (refs || []).filter((ref) => {
    const key = typeof ref === 'string' ? ref : ref?.imageId || ref?.id || JSON.stringify(ref)
    if (seen.has(key)) return false
    seen.add(key)
    return true
  })
}
